/* LUCHEMAISON theme — theme.js (no dependencies) */
(() => {
  'use strict';

  const T = window.theme || { routes: {}, strings: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const debounce = (fn, ms = 300) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const root = (T.routes.root || '/').replace(/\/?$/, '/');

  /* ---------------------------------------------------------------
     Drawers
  --------------------------------------------------------------- */
  const Drawer = {
    lastFocus: null,
    open(name) {
      const el = $(`[data-drawer="${name}"]`);
      if (!el) return false;
      this.closeAll(false);
      this.lastFocus = document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open', 'no-scroll');
      const focusable = el.querySelector('input[type="search"], button, [href], input, select');
      setTimeout(() => focusable && focusable.focus({ preventScroll: true }), 60);
      return true;
    },
    closeAll(restore = true) {
      $$('[data-drawer].is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
      document.body.classList.remove('drawer-open', 'no-scroll');
      if (restore && this.lastFocus) this.lastFocus.focus({ preventScroll: true });
    },
    isOpen(name) { const el = $(`[data-drawer="${name}"]`); return !!(el && el.classList.contains('is-open')); }
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const name = opener.dataset.drawerOpen;
      if (name === 'cart' && (T.cartType === 'page' || document.body.classList.contains('template-cart'))) return;
      if (name === 'filters' && window.matchMedia('(min-width: 990px)').matches && $('.filters--sidebar')) return;
      if (Drawer.open(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); Drawer.closeAll(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    Drawer.closeAll();
    const lb = $('[data-lightbox]:not([hidden])'); if (lb) lb.hidden = true;
  });

  /* ---------------------------------------------------------------
     Toast
  --------------------------------------------------------------- */
  const toast = (html, ms = 3200) => {
    const el = $('#Toast'); if (!el) return;
    el.innerHTML = html;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), ms);
  };

  /* ---------------------------------------------------------------
     Quantity steppers
  --------------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.closest('[data-qty]').querySelector('input');
    const min = parseInt(input.min || '0', 10);
    const next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
    if (next === parseInt(input.value, 10)) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------
     Cart
  --------------------------------------------------------------- */
  const Cart = {
    sectionIds() {
      const ids = ['cart-drawer'];
      const page = $('[data-cart-page]');
      if (page) ids.push(page.dataset.sectionId);
      return ids;
    },
    async add(form, submitter) {
      const btn = submitter || form.querySelector('[type="submit"]');
      const errorEl = form.querySelector('[data-form-error]');
      if (errorEl) errorEl.hidden = true;
      btn && btn.classList.add('is-loading');
      let body;
      try { body = new FormData(form, submitter && submitter.name ? submitter : undefined); } catch (e) { body = new FormData(form); }
      if (submitter && submitter.name && !body.has(submitter.name)) body.append(submitter.name, submitter.value);
      body.append('sections', this.sectionIds().join(','));
      body.append('sections_url', window.location.pathname);
      try {
        const res = await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
        if (T.cartType === 'page') { window.location.href = T.routes.cart; return; }
        this.render(data.sections);
        await this.refreshCount();
        if (T.cartType === 'toast') {
          toast(`<span>${T.strings.added}</span><a href="${T.routes.cart}">${T.strings.viewCart}</a>`);
        } else {
          Drawer.open('cart');
        }
        document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      } catch (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } else { toast(err.message); }
      } finally {
        btn && btn.classList.remove('is-loading');
      }
    },
    async change(line, quantity) {
      const containers = $$('[data-cart-items], [data-cart-page]');
      containers.forEach((c) => c.classList.add('is-loading'));
      try {
        const res = await fetch(`${T.routes.cartChange}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: this.sectionIds(), sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
        this.render(data.sections);
        this.setCount(data.item_count);
      } catch (err) {
        toast(err.message);
      } finally {
        $$('[data-cart-items], [data-cart-page]').forEach((c) => c.classList.remove('is-loading'));
      }
    },
    render(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        if (!html) return;
        const doc = parse(html);
        if (id === 'cart-drawer') {
          const current = $('#CartDrawer');
          const fresh = doc.querySelector('#CartDrawer');
          if (current && fresh) current.innerHTML = fresh.innerHTML;
        } else {
          const current = document.getElementById(`shopify-section-${id}`);
          const fresh = doc.getElementById(`shopify-section-${id}`);
          if (current && fresh) current.innerHTML = fresh.innerHTML;
        }
      });
    },
    async refreshCount() {
      try { const cart = await (await fetch(`${root}cart.js`)).json(); this.setCount(cart.item_count); } catch (e) { /* noop */ }
    },
    setCount(count) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      });
    }
  };

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    Cart.add(form, e.submitter);
  });

  const onLineChange = debounce((input) => Cart.change(parseInt(input.dataset.line, 10), parseInt(input.value, 10) || 0), 350);
  document.addEventListener('change', (e) => {
    const input = e.target.closest('input[data-line]');
    if (input) onLineChange(input);
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); Cart.change(parseInt(rm.dataset.lineRemove, 10), 0); }
  });
  document.addEventListener('input', debounce((e) => {
    const note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  }, 500));

  /* ---------------------------------------------------------------
     Product page
  --------------------------------------------------------------- */
  function initProduct(section) {
    if (section._init) return; section._init = true;
    const jsonEl = $('[data-product-json]', section);
    const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    const form = $('#ProductForm', section) || $('form[data-product-form]', section);
    const picker = $('[data-variant-picker]', section);
    const idInput = $('[data-variant-input]', section);
    const addBtn = $('[data-add-button]', section);
    const addText = $('[data-add-text]', section);
    const gallery = $('[data-gallery]', section);
    const lowStock = parseInt(section.dataset.lowStock || '5', 10);
    const stockStrings = $('[data-stock-strings]', section);

    const selectedOptions = () => {
      const groups = $$('fieldset', picker);
      return groups.map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
    };

    const updateAvailability = (selected) => {
      $$('fieldset', picker).forEach((fs, idx) => {
        $$('input', fs).forEach((input) => {
          const test = selected.slice(); test[idx] = input.value;
          const match = variants.find((v) => v.options.every((o, i) => o === test[i]));
          input.closest('label').classList.toggle('is-unavailable', !match || !match.available);
        });
        const checked = fs.querySelector('input:checked');
        const label = fs.querySelector('[data-option-label]');
        if (label && checked) label.textContent = checked.value;
      });
    };

    const layout = gallery ? gallery.dataset.layout : '';
    const thumbs = $$('[data-thumb]', section);
    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

    // Show one media item (thumbnail layout) or bring it to the front (grid layouts)
    const setActive = (target, { scroll = true } = {}) => {
      if (!gallery || !target) return;
      $$('.pdp__media', gallery).forEach((m) => m.classList.toggle('is-active', m === target));
      const id = target.dataset.mediaId;
      thumbs.forEach((t) => {
        const on = t.dataset.thumb === id;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        if (on && scroll) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
      if (isMobile()) {
        if (scroll) gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      } else if (layout !== 'thumbs') {
        gallery.prepend(target);
      }
    };

    // Which option is the color (the one rendered as swatches)
    const colorIndex = picker ? $$('fieldset', picker).findIndex((fs) => fs.querySelector('.opt__values--swatch')) : -1;
    const words = (text) => ` ${String(text || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim()} `;
    const altHas = (el, value) => words(el.dataset.mediaAlt).includes(words(value));
    const colorValues = colorIndex >= 0 ? [...new Set(variants.map((v) => v.options[colorIndex]))] : [];

    // Group images by color. 1) variant images, 2) alt text naming the color, 3) equal split in upload order
    const allFigures = gallery ? $$('.pdp__media', gallery) : [];
    const groupFor = (colorValue) => {
      if (colorIndex < 0 || colorValues.length < 2 || !allFigures.length) return null;
      const byAlt = allFigures.filter((f) => altHas(f, colorValue));
      if (byAlt.length) return byAlt;
      const withMedia = variants.filter((v) => v.media);
      if (withMedia.length) {
        const starts = colorValues.map((c) => {
          const v = variants.find((x) => x.options[colorIndex] === c && x.media);
          return v ? allFigures.findIndex((f) => f.dataset.mediaId === String(v.media)) : -1;
        });
        const i = colorValues.indexOf(colorValue);
        if (starts.every((n) => n >= 0)) {
          const sorted = [...starts].sort((a, b) => a - b);
          const start = starts[i];
          const next = sorted.find((n) => n > start);
          return allFigures.slice(start, next === undefined ? allFigures.length : next);
        }
      }
      if (allFigures.length % colorValues.length === 0) {
        const per = allFigures.length / colorValues.length;
        const i = colorValues.indexOf(colorValue);
        return allFigures.slice(i * per, (i + 1) * per);
      }
      return null;
    };

    const mediaForVariant = (variant) => {
      if (!gallery || !variant) return null;
      if (variant.media) {
        const byId = allFigures.find((f) => f.dataset.mediaId === String(variant.media));
        if (byId) return byId;
      }
      const group = groupFor(variant.options[colorIndex]);
      return group && group.length ? group[0] : null;
    };

    const filterByColor = (variant) => {
      if (!gallery || !variant) return;
      const group = groupFor(variant.options[colorIndex]);
      if (!group) return;
      allFigures.forEach((f) => {
        const show = group.includes(f);
        f.hidden = !show;
        const t = thumbs.find((x) => x.dataset.thumb === f.dataset.mediaId);
        if (t) t.hidden = !show;
      });
    };

    const moveMedia = (variant) => {
      filterByColor(variant);
      const target = mediaForVariant(variant);
      if (target) setActive(target);
    };

    const updateStock = (v) => {
      const wrap = $('[data-stock]', section);
      if (!wrap || !stockStrings) return;
      const text = $('[data-stock-text]', wrap);
      const frag = stockStrings.content;
      wrap.classList.remove('stock--low', 'stock--out');
      if (!v || !v.available) { wrap.classList.add('stock--out'); text.textContent = frag.querySelector('[data-out]').textContent; return; }
      if (v.tracked && v.qty > 0 && v.qty <= lowStock) {
        wrap.classList.add('stock--low');
        text.textContent = frag.querySelector('[data-low]').textContent.replace('[count]', v.qty);
        return;
      }
      text.textContent = frag.querySelector('[data-in]').textContent.trim() || T.strings.addToCart;
    };

    const onChange = () => {
      const selected = selectedOptions();
      const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
      updateAvailability(selected);

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addText.textContent = T.strings.unavailable; }
        updateStock(null);
        return;
      }
      if (idInput) { idInput.value = variant.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      $$('[data-price-wrap], [data-price-wrap-bar]', section).forEach((el) => { el.innerHTML = variant.priceHtml; });
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addText.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      }
      updateStock(variant);
      moveMedia(variant);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      section.dispatchEvent(new CustomEvent('variant:change', { detail: variant, bubbles: true }));
    };

    if (picker) {
      picker.addEventListener('change', onChange);
      updateAvailability(selectedOptions());
    }

    // thumbnails
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const target = gallery.querySelector(`[data-media-id="${t.dataset.thumb}"]`);
      setActive(target);
    }));

    // gallery dots and swipe position
    const dots = $$('[data-gallery-dots] span', section);
    if (gallery) {
      gallery.addEventListener('scroll', debounce(() => {
        if (!isMobile()) return;
        const items = $$('.pdp__media', gallery).filter((m) => !m.hidden);
        const center = gallery.scrollLeft + gallery.clientWidth / 2;
        let idx = 0;
        items.forEach((m, i) => { if (m.offsetLeft - gallery.offsetLeft <= center) idx = i; });
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
        if (items[idx]) setActive(items[idx], { scroll: false });
      }, 80));
    }

    // initial state: match the selected variant's color
    if (variants.length && idInput) {
      const initial = variants.find((v) => String(v.id) === String(idInput.value));
      if (initial) { filterByColor(initial); const t = mediaForVariant(initial); if (t) setActive(t, { scroll: false }); }
    }

    // zoom
    const lightbox = section.nextElementSibling && section.nextElementSibling.matches('[data-lightbox]') ? section.nextElementSibling : $('[data-lightbox]');
    section.addEventListener('click', (e) => {
      const z = e.target.closest('[data-zoom]');
      if (!z || !lightbox) return;
      lightbox.querySelector('img').src = z.dataset.zoom;
      lightbox.hidden = false;
    });
    if (lightbox && !lightbox._init) {
      lightbox._init = true;
      lightbox.addEventListener('click', (e) => { if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) lightbox.hidden = true; });
    }

    // mobile sticky bar
    const bar = $('[data-mobile-bar]', section);
    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(addBtn);
      $('[data-mobile-bar-btn]', bar).addEventListener('click', () => {
        if (addBtn.disabled) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click();
      });
    }
  }

  // dialogs (size guide)
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-dialog-open]');
    if (open) { const d = document.getElementById(open.dataset.dialogOpen); d && d.showModal(); return; }
    const close = e.target.closest('[data-dialog-close]');
    if (close) { close.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  // share
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-share]');
    if (!btn) return;
    const data = { title: btn.dataset.title, url: btn.dataset.url };
    try {
      if (navigator.share) await navigator.share(data);
      else { await navigator.clipboard.writeText(data.url); toast(T.strings.linkCopied); }
    } catch (err) { /* cancelled */ }
  });


  /* ---------------------------------------------------------------
     Product spotlight color switch
  --------------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-spot-swatch]');
    if (!sw) return;
    const wrap = sw.closest('[data-spotlight]');
    $$('[data-spot-swatch]', wrap).forEach((b) => b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'));
    const label = $('[data-spot-label]', wrap); if (label) label.textContent = sw.dataset.name;
    const link = $('[data-spot-link]', wrap); if (link && sw.dataset.url && sw.dataset.url !== '#') link.href = sw.dataset.url;
    [['[data-spot-main]', sw.dataset.main], ['[data-spot-second]', sw.dataset.second]].forEach(([sel, src]) => {
      const img = $(sel, wrap);
      if (!img || !src) return;
      img.style.opacity = 0;
      setTimeout(() => { img.removeAttribute('srcset'); img.src = src; img.style.opacity = 1; }, 220);
    });
  });

  /* ---------------------------------------------------------------
     Announcement rotator
  --------------------------------------------------------------- */
  function initRotator(el) {
    if (el._init) return; el._init = true;
    const items = $$('.announce__item', el);
    if (items.length < 2) return;
    let i = 0;
    const go = (n) => { items[i].classList.remove('is-active'); i = (n + items.length) % items.length; items[i].classList.add('is-active'); };
    const speed = (parseInt(el.dataset.speed, 10) || 5) * 1000;
    let timer = setInterval(() => go(i + 1), speed);
    const reset = () => { clearInterval(timer); timer = setInterval(() => go(i + 1), speed); };
    const prev = $('[data-rotator-prev]', el); const next = $('[data-rotator-next]', el);
    prev && prev.addEventListener('click', () => { go(i - 1); reset(); });
    next && next.addEventListener('click', () => { go(i + 1); reset(); });
    el.addEventListener('mouseenter', () => clearInterval(timer));
    el.addEventListener('mouseleave', reset);
  }

  /* ---------------------------------------------------------------
     Tabs
  --------------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-tab]');
    if (!tab) return;
    const wrap = tab.closest('[data-tabs]');
    $$('[data-tab]', wrap).forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
    $$('[role="tabpanel"]', wrap).forEach((p, idx) => { p.hidden = idx !== parseInt(tab.dataset.tab, 10); });
  });

  /* ---------------------------------------------------------------
     Compare slider
  --------------------------------------------------------------- */
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-compare] input[type="range"]');
    if (!input) return;
    const wrap = input.closest('[data-compare]');
    const v = input.value;
    $('.compare__top', wrap).style.clipPath = `inset(0 ${100 - v}% 0 0)`;
    $('.compare__handle', wrap).style.left = `${v}%`;
  });

  /* ---------------------------------------------------------------
     Predictive search
  --------------------------------------------------------------- */
  const searchInput = $('[data-predictive-input]');
  const searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults) {
    let controller;
    searchInput.addEventListener('input', debounce(async () => {
      const q = searchInput.value.trim();
      if (!q) { searchResults.innerHTML = ''; return; }
      controller && controller.abort();
      controller = new AbortController();
      try {
        const params = new URLSearchParams({ q, section_id: 'predictive-search', 'resources[limit]': '4', 'resources[type]': 'product,collection,page,query', 'resources[options][unavailable_products]': 'last' });
        const res = await fetch(`${T.routes.search}?${params}`, { signal: controller.signal });
        const doc = parse(await res.text());
        const section = doc.querySelector('#shopify-section-predictive-search');
        searchResults.innerHTML = section ? section.innerHTML : '';
      } catch (err) { /* aborted */ }
    }, 250));
  }

  /* ---------------------------------------------------------------
     Collection filtering, sorting, load more
  --------------------------------------------------------------- */
  function initCollection(wrap) {
    if (wrap._init) return; wrap._init = true;
    const sectionId = wrap.dataset.sectionId;

    const render = async (url, push = true) => {
      const results = $('[data-collection-results]', wrap);
      results && results.classList.add('is-loading');
      const filtersOpen = Drawer.isOpen('filters');
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);
      try {
        const html = await (await fetch(fetchUrl)).text();
        const doc = parse(html);
        const fresh = doc.querySelector('[data-collection]');
        if (fresh) {
          const openDetails = $$('details[open] summary span', wrap).map((s) => s.textContent);
          wrap.innerHTML = fresh.innerHTML;
          $$('details summary span', wrap).forEach((s) => { if (openDetails.includes(s.textContent)) s.closest('details').open = true; });
          if (filtersOpen) Drawer.open('filters');
        }
        if (push) { fetchUrl.searchParams.delete('section_id'); window.history.pushState({ collection: true }, '', fetchUrl.toString()); }
      } catch (err) {
        window.location.href = url;
      }
    };

    const buildUrl = () => {
      const params = new URLSearchParams();
      $$('[data-filter-form]', wrap).forEach((f) => {
        new FormData(f).forEach((value, key) => { if (value !== '' && !(key === 'sort_by' && params.has('sort_by'))) params.append(key, value); });
      });
      return `${window.location.pathname}?${params.toString()}`;
    };

    const onFilter = debounce(() => render(buildUrl()), 450);
    wrap.addEventListener('change', (e) => { if (e.target.closest('[data-autofilter]')) onFilter(); });
    wrap.addEventListener('submit', (e) => { if (e.target.closest('[data-filter-form]')) { e.preventDefault(); render(buildUrl()); } });
    wrap.addEventListener('click', async (e) => {
      const link = e.target.closest('[data-filter-link]');
      if (link) { e.preventDefault(); render(link.href); return; }
      const more = e.target.closest('[data-load-more]');
      if (more) {
        e.preventDefault();
        more.classList.add('is-loading');
        const url = new URL(more.href, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        const doc = parse(await (await fetch(url)).text());
        const grid = $('.product-grid', wrap);
        const freshGrid = doc.querySelector('.product-grid');
        if (grid && freshGrid) grid.append(...freshGrid.children);
        const freshMore = doc.querySelector('.load-more');
        const currentMore = $('.load-more', wrap);
        if (freshMore) currentMore.replaceWith(freshMore); else currentMore.remove();
      }
    });
    if (!window._collectionPop) {
      window._collectionPop = true;
      window.addEventListener('popstate', () => { const w = $('[data-collection]'); if (w) window.location.reload(); });
    }
  }

  /* ---------------------------------------------------------------
     Product recommendations
  --------------------------------------------------------------- */
  async function initRecommendations(el) {
    if (el._init || !el.dataset.url) return; el._init = true;
    if (el.querySelector('.product-grid')) return;
    try {
      const doc = parse(await (await fetch(el.dataset.url)).text());
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (err) { /* noop */ }
  }

  /* ---------------------------------------------------------------
     Floating country / currency switcher
  --------------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-float-toggle]');
    const wrap = $('[data-float-localization]');
    if (!wrap) return;
    const panel = $('.lm-float__panel', wrap);
    if (toggle) {
      const open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      wrap.classList.toggle('is-open', open);
      return;
    }
    if (!e.target.closest('[data-float-localization]') && !panel.hidden) {
      panel.hidden = true;
      wrap.classList.remove('is-open');
      $('[data-float-toggle]', wrap).setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const wrap = $('[data-float-localization].is-open');
    if (!wrap) return;
    $('.lm-float__panel', wrap).hidden = true;
    wrap.classList.remove('is-open');
  });

  /* ---------------------------------------------------------------
     Misc
  --------------------------------------------------------------- */
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-autosubmit]');
    if (s) s.form.submit();
  });

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-auth-toggle]');
    if (!t) return;
    e.preventDefault();
    $$('[data-auth-panel]').forEach((p) => { p.hidden = p.dataset.authPanel !== t.dataset.authToggle; });
  });
  if (window.location.hash === '#recover') {
    $$('[data-auth-panel]').forEach((p) => { p.hidden = p.dataset.authPanel !== 'recover'; });
  }

  const header = $('[data-header]');
  if (header && header.classList.contains('header--transparent')) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  // Footer menus collapsed on mobile
  const syncFooter = () => {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    $$('.footer__collapse').forEach((d) => { if (!d._touched) d.open = !mobile; });
  };
  document.addEventListener('toggle', (e) => { if (e.target.classList && e.target.classList.contains('footer__collapse')) e.target._touched = true; }, true);

  /* ---------------------------------------------------------------
     Init + theme editor support
  --------------------------------------------------------------- */
  // The menu drawer is rendered inside the header section, which creates its own
  // stacking context. Move it to <body> so it sits above the page overlay.
  function liftMenuDrawer() {
    const drawer = document.querySelector('[data-drawer="menu"]');
    if (!drawer || drawer.parentElement === document.body) return;
    document.querySelectorAll('body > [data-drawer="menu"]').forEach((old) => old.remove());
    document.body.appendChild(drawer);
  }

  function init(scope = document) {
    liftMenuDrawer();
    $$('[data-product-section]', scope).forEach(initProduct);
    $$('[data-rotator]', scope).forEach(initRotator);
    $$('[data-collection]', scope).forEach(initCollection);
    $$('[data-recommendations]', scope).forEach(initRecommendations);
    syncFooter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const item = e.target.closest('.announce__item');
    if (item) { $$('.announce__item', item.parentElement).forEach((i) => i.classList.toggle('is-active', i === item)); }
    const tab = e.target.closest('[data-tab]'); if (tab) tab.click();
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('#CartDrawer')) Drawer.open('cart');
  });

  window.LuchemaisonTheme = { Drawer, Cart, toast };
})();
